export const ROLES = {
  // Superb roles (for internal users)
  SUPERB_ADMIN: 'superb_admin',
  SUPERB_MEMBER: 'superb_member',

  // Organization roles (for client users)
  ADMIN: 'admin',
  MEMBER: 'member',
} as const;

export const ROLE_LABELS = {
  [ROLES.SUPERB_ADMIN]: 'Superb Admin',
  [ROLES.SUPERB_MEMBER]: 'Superb Member',
  [ROLES.ADMIN]: 'Admin',
  [ROLES.MEMBER]: 'Member',
} as const;

export const SUPERB_ROLES = [
  { value: ROLES.SUPERB_MEMBER, label: ROLE_LABELS[ROLES.SUPERB_MEMBER] },
  { value: ROLES.SUPERB_ADMIN, label: ROLE_LABELS[ROLES.SUPERB_ADMIN] },
];

export const ORGANIZATION_ROLES = [
  { value: ROLES.MEMBER, label: ROLE_LABELS[ROLES.MEMBER] },
  { value: ROLES.ADMIN, label: ROLE_LABELS[ROLES.ADMIN] },
];

export type Role = (typeof ROLES)[keyof typeof ROLES];
